import React from 'react';
import styles from './SuccesfulUploadMessage.module.scss';
import classnames from 'classnames';
import importDataIcon from 'v2/icons/import-data-icon.svg';

const InProgressUploadMessage = () => {
  return (
    <div className={classnames(styles.successfulImportLoadContainer)}>
      <div className={classnames(styles.message)}>
        <strong className={classnames(styles.label)}>
          Your file is being imported!
        </strong>
        <p>
          It may take a few minutes to populate all of your imported entities...
        </p>
      </div>
      <img
        className={classnames(styles.importDataIcon)}
        src={importDataIcon}
        alt="file icon"
      />
    </div>
  );
};

export default InProgressUploadMessage;
